import type { ReactElement } from 'react'
import {
  type DashTableDatum,
  type DashTableIntlProps,
  type DashTableBaseFiltersType,
} from './utils/dashTable.types'
import { useDashTableBehaviour, type UseDashTableBehaviour } from './utils/dashTable.utils'
import { DashTableContent } from './DashTableContent'

export type DashTableProps<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TData extends DashTableDatum = any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TFilters extends DashTableBaseFiltersType = any
> = UseDashTableBehaviour<TData, TFilters> & DashTableIntlProps

export function DashTable<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TData extends DashTableDatum = any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TFilters extends DashTableBaseFiltersType = any
>(props: DashTableProps<TData, TFilters>): ReactElement {
  const behaviour = useDashTableBehaviour<TData, TFilters>(props)

  return <DashTableContent<TData> {...props} {...behaviour} />
}
